export default __webpack_public_path__ + "static/media/video-cut1.123b37cc.mp4";